import React, { Component } from 'react';
import TeX from 'react-components/tex';

const ResultRow = React.createClass({

    render(){

        let isCorrect = this.props.isCorrect || false,
            state,
            icon;

        if(isCorrect === true) {
            state = 'Correct'
            icon = 'ok';
        } else {
            state = 'Wrong'
            icon = 'remove';
        }

        return (
            <div className={'exercise-result-row is'+state}>
                <span className="exercise-result-row--result">{this.props.children}</span>
                <span className={'exercise-result-row--state'}>
                    {isCorrect ? 'Rätt' :'Fel'}
                </span>
            </div>
        );
    }
});


export default ResultRow;


/** WEBPACK FOOTER **
 ** ./src/components/ExerciseResult/ExerciseResult.js
 **/